// extracted by mini-css-extract-plugin
export default {"imgMainDiv":"ElectronicsSingleItem_imgMainDiv__rlrr6","container":"ElectronicsSingleItem_container__GxQXh","details":"ElectronicsSingleItem_details__X+0oV"};